module.exports = __webpack_public_path__ + "static/pod-become-active-e55ca3dccfc86b144fa3bf5e413db8b9.jpg";